import React from 'react';
import Select from 'react-select';
import 'bootstrap/dist/css/bootstrap.min.css';

const options = [
  { value: 'apple', label: 'Apple' },
  { value: 'banana', label: 'Banana' },
  { value: 'cherry', label: 'Cherry' },
  { value: 'date', label: 'Date' },
  { value: 'elderberry', label: 'Elderberry' },
  { value: 'fig', label: 'Fig' },
  { value: 'grape', label: 'Grape' },
  { value: 'honeydew', label: 'Honeydew' },
];
const DeliveryInformation = () => {
  return (
      <Select
        options={options}
        isSearchable={true}
        className="react-select-container"
        classNamePrefix="react-select"
        styles={{ borderColor:"#000 !important" }}
      />
  );
};
export default DeliveryInformation;
